import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IOrganizationState } from '../../interfaces/state.interfaces';
import { IOrganization } from '../../interfaces/organization.interface';

const initialState: IOrganizationState = {
    id: null,
    name: null,
    email: null,
    subscriptionStatus: null,
};

const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    reducers: {
        SetOrganizationDetails(state, action: PayloadAction<IOrganization>) {
            state.id = action.payload.id;
            state.name = action.payload.name;
            state.email = action.payload.email;
            state.subscriptionStatus = action.payload.subscriptionStatus;
        },
        SetOrganizationSubscriptionStatus(state, action: PayloadAction<boolean | null>) {
            state.subscriptionStatus = action.payload;
        },
        SetOrganizationInitialState(state) {
            state.id = null;
            state.name = null;
            state.email = null;
            state.subscriptionStatus = null;
        },
    },
});

export const {
    SetOrganizationDetails,
    SetOrganizationSubscriptionStatus,
    SetOrganizationInitialState,
} = organizationSlice.actions;

export const organizationReducer = organizationSlice.reducer;
